export const meetingCategories = ["pro", "biz", "education", "zoneduschcmp"];
export const proPlusCategories = ["zonepropzvu"];
export const bizPlusCategories = ["zonebizpzvu", "zonebizpzuu", "zonebizpzau", "ZONEBIZPZJU", "ZONEBIZPZSU"];
export const eduPlusCategories = ["zoneduschcmppusca", "zoneduschcmppukir", "zoneduschcmppaunz"];
export const basicPlusCategories = ["zobasicp", "zobasicpm"];
export const zrCategories = ["zr"];
export const largeCategories = ["large500", "large1000", "large3000", "large5000"];
export const webinarCategories = [
  "webinar100",
  "webinar300",
  "webinar500",
  "webinar1000",
  "webinar3000",
  "webinar5000",
  "webinar10000",
];
export const CMRCategories = [
  "cmr30",
  "cmr40_upgrade",
  "cmr100_upgrade",
  "cmr500_upgrade",
  "cmr40",
  "cmr100",
  "cmr500",
];
export const SDKCategories = ["sdkpayongo"];
export const SDKUCCategories = ['zsdkuc100', 'zsdkuc500'];

// "zoomunited" -> (no corresponding data found)
// "zoomone" -> (no corresponding data found)

// 1. Base dependency rules - Most addon plans depend on base plans
export const basePlanWithoutZrCategories = [
  ...meetingCategories,
  ...proPlusCategories,
  ...bizPlusCategories,
  ...eduPlusCategories,
];

export const basePlanCategories = [...basePlanWithoutZrCategories, ...zrCategories];

// Events related dependency rules
export const eventsUnlimitedCategory = ['eventsaas100', 'eventsaas500', 'eventsaas1000', 'eventsaas3000'];
export const eventsPPACategory = [
  'zeca_yearly50',
  'zeca_yearly100',
  'zeca_yearly600',
  'zeca_yearly1000',
  'zeca_yearly3000',
  'zeca_yearly5000',
  'zeca_yearly10000',
];
export const sessionsUnlimitedCategory = [
  'eventsaascore100',
  'eventsaascore500',
  'eventsaascore1000',
  'eventsaascore3000',
];
export const sessionsPPACategory = [
  "zecc_yearly50",
  "zecc_yearly100",
  "zecc_yearly600",
  "zecc_yearly1000",
  "zecc_yearly3000",
  "zecc_yearly5000",
  "zecc_yearly10000",
];

export const USCallingCategories = ["ZVU", "ZVM"];

export const UKCallingCategories = ["ZUU", "ZUM"];

export const AUSCallingCategories = ["ZAU", "ZAM"];

export const JapanCallingCategories = ["ZJU", "ZJM"];

export const GlobalCallingCategories = ["ZSU", "ZSM"];

export const IndiaCallingCategories = ["ZINM", "ZINP", "ZINU"];

export const ZPCallingPlanCategories = [
  ...USCallingCategories,
  ...UKCallingCategories,
  ...AUSCallingCategories,
  ...JapanCallingCategories,
  "ZPP",
  "ZCA",
  ...GlobalCallingCategories,
  ...IndiaCallingCategories,
];

export const ZoomPhoneCategories = [
  "ZVP",
  "ZVC",
  ...ZPCallingPlanCategories,
  "ZVT",
  "ZVD",
  "ZUT",
  "ZUD",
  "ZAT",
  "ZNT",
  "ZAD",
  "ZPD",
  "ZJD",
  "ZSD",
  "ZGT",
  "ZIND",
  // ...proPlusCategories,
  // ...bizPlusCategories,
];

export const zcmCategories = ["zcm_storage_30", "zcm_storage_200", "zcm_storage_1tb", "zcm_storage_5tb"];
